module.exports = {"buildDate":"25 Mar 2026","buildNumber":21,"version":"1.0.0"}


//////////////////
// WEBPACK FOOTER
// ./src/build-info.json
// module id = 1736
// module chunks = 2